// * ag-grid renders popups inside .ag-root-wrapper by default, which caps them
// * at the grid's height (.ag-menu { max-height: 100% }) and shifts tall
// * filter popups up over the sticky header (the WAP-1490 "tucked under the
// * table-header" symptom). Parenting popups to a body-level element gives
// * them the whole viewport instead.
// *
// * The parent must be a dedicated element, never <body> itself: the theme
// * scopes its variables to `.ag-root-wrapper, .ag-measurement-container,
// * .ag-apply-theme-variables` and exports `--ag-inherited-*` from every
// * grid's direct parent (`:has(> .ag-root-wrapper)`). Tagging <body> with the
// * variables class makes every grid a "nested" grid and pairs
// * `--ag-header-background-color` with its own `--ag-inherited-*` twin on the
// * same element - a var() cycle that computes to invalid and wipes the header
// * background app-wide. The detached root carries the variables class so the
// * popups it hosts keep the theme (ag-grid copies the `ag-theme-*` class onto
// * popup wrappers by itself); its layout and stacking live in
// * _ag-grid-overrides.scss under `.sensika-ag-popup-root`.
let popupRoot: HTMLElement | null = null;

export function agGridBodyPopupParent(): HTMLElement {
  if (!popupRoot || !document.body.contains(popupRoot)) {
    popupRoot = document.createElement('div');
    popupRoot.className = 'sensika-ag-popup-root ag-apply-theme-variables';
    document.body.appendChild(popupRoot);
  }
  return popupRoot;
}
